import React from 'react';
import './SideNav.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoon,
  faCodeBranch, faBriefcase, faProjectDiagram, faGlobe, faTasks, faHourglass, faUserTie, faUserFriends, faPlane, faGamepad, faUserSecret, faDownload, faTv, faPlus, faExchangeAlt, faPowerOff, faPencilAlt, faEdit, faSmile, faInfo, faUsers, faIdCardAlt, faUserMinus, faLaptop, faChartLine, faSearchPlus, faQuestionCircle, faIdBadge, faAlignRight, faChevronDown, faChevronLeft, faBars, faHourglassEnd, faPuzzlePiece, faHandPaper, faListOl, faBusinessTime, faSchool, faStopCircle, faWalking, faBed, faStopwatch, faSignInAlt, faFileAlt, faUsersSlash, faBan
} from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery';
const toggleSubMenu = (e) => {
  const toggledMenu = e.currentTarget.nextElementSibling;
  toggledMenu.classList.toggle("visible");
}


const SideNavAr = ({ activatePage, toggleSideNav, hideSideNav, activePage, permissions }) => {
  let mywidth = document.getElementsByTagName('body')[0].offsetWidth;
  const toggleNav = () => {
    if (mywidth < 991) return toggleSideNav();
  }
  return (
    <aside className='side-ar show-side-nav' style={{ textAlign: 'right' }}>
      <div className='header--side-toggle-buttonAr'>

        <button
          id='SideToggleButton'
          onClick={toggleSideNav}
        >
          <FontAwesomeIcon id="toggle_btn" className="d-none d-md-block" icon={faAlignRight}></FontAwesomeIcon>
          <FontAwesomeIcon id="mobile_btn" className="mobile_btn  d-block d-md-none" icon={faBars}></FontAwesomeIcon>
        </button>
      </div>
      <div id='sideNav' className='SideNav-- SideNav--ar show-side-nav'>

        {permissions ?
          <>
            {permissions.find(tab => tab.id === 1) ?
              <nav className='SideNav--main'>
                <button
                  className='SideNav--main'
                  onClick={(e) => {
                    toggleSubMenu(e);
                    if ($("#downIcon").hasClass("d-block")) {
                      $("#downIcon").removeClass("d-block")
                      $("#downIcon").addClass("d-none")
                      $("#leftIcon").removeClass("d-none")
                      $("#leftIcon").addClass("d-block")

                    }
                    else if ($("#leftIcon").hasClass("d-block")) {
                      $("#leftIcon").removeClass("d-block")
                      $("#leftIcon").addClass("d-none")
                      $("#downIcon").addClass("d-block")
                      $("#downIcon").removeClass("d-none")
                    }
                  }}
                >
                  <span>البيانات الأساسية</span>
                  <FontAwesomeIcon id="downIcon" className="d-none menu-arrow" icon={faChevronDown}></FontAwesomeIcon>
                  <FontAwesomeIcon id="leftIcon" className="d-block menu-arrow" icon={faChevronLeft}></FontAwesomeIcon>
                </button>
                <nav className='SideNav--sub visible'>
                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 1)?.
                  data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "Branches" ? "active" : null}`}
                      onClick={() => { activatePage("Branches"); toggleNav(); }}
                      to='/Ar/TAW/Main/Branches'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faCodeBranch} /> &nbsp;
                      <span>الفروع</span>
                    </Link>
                    :
                    null
                  }
                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 2)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "Jobs" ? "active" : null}`}
                      onClick={() => { activatePage("Jobs"); toggleNav(); }}
                      to='/Ar/TAW/Main/Jobs'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faBriefcase} />&nbsp;
                      <span>الوظائف</span>
                    </Link>

                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 3)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "Projects" ? "active" : null}`}
                      onClick={() => { activatePage("Projects"); toggleNav(); }}
                      to='/Ar/TAW/Main/Projects'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faProjectDiagram} />&nbsp;
                      <span>المشاريع</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 4)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "Nationalities" ? "active" : null}`}
                      onClick={() => { activatePage("Nationalities"); toggleNav(); }}
                      to='/Ar/TAW/Main/Nationalities'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faGlobe} />&nbsp;
                      <span>الجنسيات</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 5)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "Tasks" ? "active" : null}`}
                      onClick={() => { activatePage("Tasks"); toggleNav(); }}
                      to='/Ar/TAW/Main/Tasks'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faTasks} />&nbsp;
                      <span>المهام</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 6)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "WorkingTime" ? "active" : null}`}
                      onClick={() => { activatePage("WorkingTime"); toggleNav(); }}
                      to='/Ar/TAW/Main/WorkingTime'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faHourglass} />&nbsp;
                      <span>أوقات العمل</span>
                    </Link>
                    :
                    null
                  }


                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 7)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "Employees" ? "active" : null}`}
                      onClick={() => { activatePage("Employees"); toggleNav(); }}
                      to='/Ar/TAW/Main/Employees'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faUserTie} />&nbsp;
                      <span>الموظفون</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 8)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "EmployeesGroups" ? "active" : null}`}
                      onClick={() => { activatePage("EmployeesGroups"); toggleNav(); }}
                      to='/Ar/TAW/Main/EmployeesGroups'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faUserFriends} />&nbsp;
                      <span>مجموعات الموظفين</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 9)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "VacationsTypes" ? "active" : null}`}
                      onClick={() => { activatePage("VacationsTypes"); toggleNav(); }}
                      to='/Ar/TAW/Main/VacationsTypes'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faPlane} />&nbsp;
                      <span>أنواع الأجازات</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 10)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "OfficialHolidays" ? "active" : null}`}
                      onClick={() => { activatePage("OfficialHolidays"); toggleNav(); }}
                      to='/Ar/TAW/Main/OfficialHolidays'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faGamepad} />&nbsp;
                      <span>العطلات الرسمية</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 1).data.find(page => page.id === 11)?.data.find(permission => permission.nameEn === 'Get') ?

                    <Link
                      className={`${activePage === "UnregisteredEmployees" ? "active" : null}`}
                      onClick={() => { activatePage("UnregisteredEmployees"); toggleNav(); }}
                      to='/Ar/TAW/Main/UnregisteredEmployees'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faUserSecret} />&nbsp;
                      <span>موظفون غير مسجلين</span>
                    </Link>
                    :
                    null
                  }
                </nav>
              </nav>
              :
              null
            }

            {permissions.find(tab => tab.id === 2) ?
              <nav className='SideNav--main'>
                <button
                  className='SideNav--main'
                  onClick={(e) => {
                    toggleSubMenu(e);
                    if ($("#downIcon1").hasClass("d-block")) {
                      $("#downIcon1").removeClass("d-block")
                      $("#downIcon1").addClass("d-none")
                      $("#leftIcon1").removeClass("d-none")
                      $("#leftIcon1").addClass("d-block")

                    }
                    else if ($("#leftIcon1").hasClass("d-block")) {
                      $("#leftIcon1").removeClass("d-block")
                      $("#leftIcon1").addClass("d-none")
                      $("#downIcon1").addClass("d-block")
                      $("#downIcon1").removeClass("d-none")
                    }
                  }}
                >
                  <span>الإجراءات</span>
                  <FontAwesomeIcon id="downIcon1" className="d-none menu-arrow" icon={faChevronDown}></FontAwesomeIcon>
                  <FontAwesomeIcon id="leftIcon1" className="d-block menu-arrow" icon={faChevronLeft}></FontAwesomeIcon>
                </button>
                <nav className='SideNav--sub visible'>
                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 12)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "GetBranchTransactions" ? "active" : null}`}
                      onClick={() => { activatePage("GetBranchTransactions"); toggleNav(); }}
                      to='/Ar/TAW/Main/GetBranchTransactions'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faDownload} />&nbsp;
                      <span>سحب حركات الفروع</span>
                    </Link>
                    :
                    null
                  }


                  {/* <Link
              className={`${activePage === "cancel" ? "active" : null}`}
              onClick={() => {activatePage("cancel")}
              to='/Ar/TAW/Main/cancel'
            >
              <i className='fa fa-group'>&nbsp;</i>
              <span>Cancel (FTP)</span>
            </Link> */}
                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 14)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "DisplayTransactions" ? "active" : null}`}
                      onClick={() => { activatePage("DisplayTransactions"); toggleNav(); }}
                      to='/Ar/TAW/Main/DisplayTransactions'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faTv} />&nbsp;
                      <span>عرض الحركات</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 17)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "AddPermission" ? "active" : null}`}
                      onClick={() => { activatePage("AddPermission"); toggleNav(); }}
                      to='/Ar/TAW/Main/AddPermission'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faPlus} />&nbsp;
                      <span>إضافة إذن</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 18)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "AddVacation" ? "active" : null}`}
                      onClick={() => { activatePage("AddVacation"); toggleNav(); }}
                      to='/Ar/TAW/Main/AddVacation'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faEdit} />&nbsp;
                      <span>إضافة إجازة</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 13)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "TransferTransactions" ? "active" : null}`}
                      onClick={() => { activatePage("TransferTransactions"); toggleNav(); }}
                      to='/Ar/TAW/Main/TransferTransactions'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faExchangeAlt} />&nbsp;
                      <span>ترحيل حركات</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 15)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "CancelTransferTransactions" ? "active" : null}`}
                      onClick={() => { activatePage("CancelTransferTransactions"); toggleNav(); }}
                      to='/Ar/TAW/Main/CancelTransferTransactions'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faPowerOff} />&nbsp;
                      <span>إلغاء ترحيل حركات</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 2).data.find(page => page.id === 16)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "AddEditTransactions" ? "active" : null}`}
                      onClick={() => { activatePage("AddEditTransactions"); toggleNav(); }}
                      to='/Ar/TAW/Main/AddEditTransactions'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faPencilAlt} />&nbsp;
                      <span>إضافة و تعديل حركات</span>
                    </Link>
                    :
                    null
                  }

                  <Link
                    className={`${activePage === "CancelManuallyTrans" ? "active" : null}`}
                    onClick={() => { activatePage("CancelManuallyTrans"); toggleNav(); }}
                    to='/Ar/TAW/Main/CancelManuallyTrans'
                  >
                    <FontAwesomeIcon className="sideNav-icon" icon={faBan} />&nbsp;
                    <span>إلغاء الحركات المعدلة يدوياً</span>
                  </Link>

                  {/* <Link
              className={`${activePage === "DeleteEmployeesData" ? "active" : null}`}
              onClick={() => {activatePage("DeleteEmployeesData")}
              to='/Ar/TAW/Main/DeleteEmployeesData'
            >
              <i className='fa fa-group'>&nbsp;</i>
              <span>Delete Employees Data</span>
            </Link> */}
                </nav>
              </nav>
              :
              null
            }

            {permissions.find(tab => tab.id === 3) ?
              <nav className='SideNav--main'>
                <button
                  className='SideNav--main'
                  onClick={(e) => {
                    toggleSubMenu(e);
                    if ($("#downIcon2").hasClass("d-block")) {
                      $("#downIcon2").removeClass("d-block")
                      $("#downIcon2").addClass("d-none")
                      $("#leftIcon2").removeClass("d-none")
                      $("#leftIcon2").addClass("d-block")

                    }
                    else if ($("#leftIcon2").hasClass("d-block")) {
                      $("#leftIcon2").removeClass("d-block")
                      $("#leftIcon2").addClass("d-none")
                      $("#downIcon2").addClass("d-block")
                      $("#downIcon2").removeClass("d-none")
                    }
                  }}
                >
                  <span>التقارير</span>
                  <FontAwesomeIcon id="downIcon2" className="d-none menu-arrow" icon={faChevronDown}></FontAwesomeIcon>
                  <FontAwesomeIcon id="leftIcon2" className="d-block menu-arrow" icon={faChevronLeft}></FontAwesomeIcon>
                </button>
                <nav className='SideNav--sub visible'>
                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 19)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "EmployeesReport" ? "active" : null}`}
                      onClick={() => { activatePage("EmployeesReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/EmployeesReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faIdBadge} />&nbsp;
                      <span>الموظفون</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 20)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "WorkingTimeReport" ? "active" : null}`}
                      onClick={() => { activatePage("WorkingTimeReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/WorkingTimeReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faIdBadge} />&nbsp;
                      <span>أوقات العمل</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 21)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "DayStatusReport" ? "active" : null}`}
                      onClick={() => { activatePage("DayStatusReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/DayStatusReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faQuestionCircle} />&nbsp;
                      <span>حالة اليوم</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 22)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "DetailedAttendanceReport" ? "active" : null}`}
                      onClick={() => { activatePage("DetailedAttendanceReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/DetailedAttendanceReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faSearchPlus} />&nbsp;
                      <span>حضور تفصيلي</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 23)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "TotalAttendanceReport" ? "active" : null}`}
                      onClick={() => { activatePage("TotalAttendanceReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/TotalAttendanceReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faChartLine} />&nbsp;
                      <span>حضور إجمالي</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 24)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "AbsenceReport" ? "active" : null}`}
                      onClick={() => { activatePage("AbsenceReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/AbsenceReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faUserMinus} />&nbsp;
                      <span>غياب</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 25)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "DelayReport" ? "active" : null}`}
                      onClick={() => { activatePage("DelayReport"); toggleNav(); }}
                      to={'/Ar/TAW/Main/DelayReport'}
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faHourglassEnd} />&nbsp;
                      <span>تأخير</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 26)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "InCompleteTransReport" ? "active" : null}`}
                      onClick={() => { activatePage("InCompleteTransReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/InCompleteTransReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faPuzzlePiece} />&nbsp;
                <span>حركات غير مكتملة</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 27)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "EarlyAttendanceReport" ? "active" : null}`}
                      onClick={() => { activatePage("EarlyAttendanceReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/EarlyAttendanceReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faHandPaper} />&nbsp;
                      <span>حضور مبكر</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 28)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "AttendanceSummaryReport" ? "active" : null}`}
                      onClick={() => { activatePage("AttendanceSummaryReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/AttendanceSummaryReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faSignInAlt} />&nbsp;
                      <span>ملخص تقرير حضور</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 29)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "TotalAttendanceSummaryReport" ? "active" : null}`}
                      onClick={() => { activatePage("TotalAttendanceSummaryReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/TotalAttendanceSummaryReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faListOl} />&nbsp;
                      <span>ملخص الحضور الكلي للفروع</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 30)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "OvertimeReport" ? "active" : null}`}
                      onClick={() => { activatePage("OvertimeReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/OvertimeReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faBusinessTime} />&nbsp;
                      <span>الإضافي</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 31)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "WorkingTimeDetailsReport" ? "active" : null}`}
                      onClick={() => { activatePage("WorkingTimeDetailsReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/WorkingTimeDetailsReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faFileAlt} />&nbsp;
                      <span>دوام الموظفين التفصيلي</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 32)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "BranchAttendanceReport" ? "active" : null}`}
                      onClick={() => { activatePage("BranchAttendanceReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/BranchAttendanceReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faSchool} />&nbsp;
                      <span>الحضور و الانصراف بالفروع</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 33)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "VacationsReport" ? "active" : null}`}
                      onClick={() => { activatePage("VacationsReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/VacationsReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faStopCircle} />&nbsp;
                      <span> أجازات الموظفين</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 34)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "PermissionsReport" ? "active" : null}`}
                      onClick={() => { activatePage("PermissionsReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/PermissionsReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faWalking} />&nbsp;
                      <span> اذونات الموظفين</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 35)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "DelayEarlyReport" ? "active" : null}`}
                      onClick={() => { activatePage("DelayEarlyReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/DelayEarlyReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faBed} />&nbsp;
                      <span> التاخير والانصراف المبكر</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 36)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "TotalAbsenceReport" ? "active" : null}`}
                      onClick={() => { activatePage("TotalAbsenceReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/TotalAbsenceReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faUsersSlash} />&nbsp;
                      <span>اجمالي الغياب  </span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 3).data.find(page => page.id === 37)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "TotalDelayReport" ? "active" : null}`}
                      onClick={() => { activatePage("TotalDelayReport"); toggleNav(); }}
                      to='/Ar/TAW/Main/TotalDelayReport'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faStopwatch} />&nbsp;
                      <span>اجمالي التأخير  </span>
                    </Link>
                    :
                    null
                  }
                </nav>
              </nav>
              :
              null
            }

            {permissions.find(tab => tab.id === 4) ?
              <nav className='SideNav--main'>
                <button
                  className='SideNav--main'
                  onClick={(e) => {
                    toggleSubMenu(e);
                    if ($("#downIcon3").hasClass("d-block")) {
                      $("#downIcon3").removeClass("d-block")
                      $("#downIcon3").addClass("d-none")
                      $("#leftIcon3").removeClass("d-none")
                      $("#leftIcon3").addClass("d-block")

                    }
                    else if ($("#leftIcon3").hasClass("d-block")) {
                      $("#leftIcon3").removeClass("d-block")
                      $("#leftIcon3").addClass("d-none")
                      $("#downIcon3").addClass("d-block")
                      $("#downIcon3").removeClass("d-none")
                    }
                  }}
                >
                  <span>الإعدادات</span>
                  <FontAwesomeIcon id="downIcon3" className="d-none menu-arrow" icon={faChevronDown}></FontAwesomeIcon>
                  <FontAwesomeIcon id="leftIcon3" className="d-block menu-arrow" icon={faChevronLeft}></FontAwesomeIcon>
                </button>
                <nav className='SideNav--sub visible'>
                  {permissions.find(tab => tab.id === 4).data.find(page => page.id === 38)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "Devices" ? "active" : null}`}
                      onClick={() => { activatePage("Devices"); toggleNav(); }}
                      to='/Ar/TAW/Main/Devices'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faLaptop} />&nbsp;
                      <span>الأجهزة</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 4).data.find(page => page.id === 39)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "SpecialWorkingDays" ? "active" : null}`}
                      onClick={() => { activatePage("SpecialWorkingDays"); toggleNav(); }}
                      to='/Ar/TAW/Main/SpecialWorkingDays'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faMoon} />&nbsp;
                      <span>تفعيل دوام  رمضان</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 4).data.find(page => page.id === 40)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "UserPermission" ? "active" : null}`}
                      onClick={() => { activatePage("UserPermission"); toggleNav(); }}
                      to='/Ar/TAW/Main/UserPermission'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faIdCardAlt} />&nbsp;
                      <span>الصلاحيات</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 4).data.find(page => page.id === 43)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "UsersAccounts" ? "active" : null}`}
                      onClick={() => { activatePage("UsersAccounts"); toggleNav(); }}
                      to='/Ar/TAW/Main/UsersAccounts'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faUsers} />&nbsp;
                      <span>حسابات المستخدمين</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 4).data.find(page => page.id === 42)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`${activePage === "CompanyInfo" ? "active" : null}`}
                      onClick={() => { activatePage("CompanyInfo"); toggleNav(); }}
                      to='/Ar/TAW/Main/CompanyInfo'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faInfo} />&nbsp;
                      <span>بيانات الشركة</span>
                    </Link>
                    :
                    null
                  }

                  {permissions.find(tab => tab.id === 4).data.find(page => page.id === 41)?.data.find(permission => permission.nameEn === 'Get') ?
                    <Link
                      className={`pb-40 ${activePage === "GeneralSettings" ? "active" : null}`}
                      onClick={() => { activatePage("GeneralSettings"); toggleNav(); }}
                      to='/Ar/TAW/Main/GeneralSettings'
                    >
                      <FontAwesomeIcon className="sideNav-icon" icon={faSmile} />&nbsp;
                      <span>الاعدادات العامة</span>
                    </Link>
                    :
                    null
                  }

                </nav>
              </nav>
              :
              null
            }
          </>
          :
          null}
      </div>
      <div className="overlay" onClick={hideSideNav}></div>
    </aside>
  )
}
export default SideNavAr;